import * as fromAddres from './address.actions';
import { Address, IAddress } from '../models/address.model';

export interface AddressState {
    address: IAddress;
}

const estadoInicial: AddressState = {
    address: null
};


export function addressReducer(state = estadoInicial, action: fromAddres.acciones): AddressState {

    switch (action.type) {

        case fromAddres.SET_ADDRESS:
            return {
                ...state,
                address: action.address
            };

        case fromAddres.UNSET_ADDRESS:
            return {
                address: null
            };

        default:
            return state;

    }

}